/**
 * Параметр отвечающий за включение изменений по замене хэштегов в отзывах/вопросах/комментариях
 */
export const isHashtagToSearchEnabled = (() => {
  if (process.env.NODE_ENV === 'test') {
    return true
  }
  return window.app && window.app.isHashtagToSearchEnabled
})()
